<template>
    <modal v-if="showModal" @close="$emit('closeModal')">
        <template slot="header">
            <h4 class="modal-title">{{title}}</h4>
            <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="$emit('closeModal')">
                <md-icon>clear</md-icon>
            </md-button>
        </template>

        <template slot="body">
            <multiselect
                    v-model="selected"
                    deselect-label="Can't remove this value"
                    track-by="name"
                    :multiple="multiple"
                    label="name"
                    placeholder="Select Activity to Add"
                    :options="activities"
                    :searchable="true"
                    :allow-empty="false"
                    >
            </multiselect>
        </template>

        <template slot="footer">
            <md-button class="md-primary md-simple" @click="$emit('add:activity',selected)">Add Selected Activity(s)</md-button>
            <md-button
                    class="md-danger md-simple"
                    @click="$emit('closeModal')">Close
            </md-button>
        </template>
    </modal>
</template>

<script>
import {
    Modal
} from '@/components';
import Multiselect from 'vue-multiselect';

export default {
    name: 'AddActivityModal',
    components: { Modal, Multiselect },
    props:{
        title:{
            type:String,default:'Add activity'
        },
        showModal:{
            type:Boolean,default: false
        },
        multiple:{
            type:Boolean,default: true
        }
    },
    data () {
        return {
            'activities':[],
            selected:[]
        };
    },
    created () {
        this.fetchData();
    },
    methods:{
        async fetchData () {
            const params = {
                filter:{ hasTariff:'true' }
            };
            await this.$store.dispatch('activities/list', params).then(() => {
                this.activities = this.$store.getters['activities/list'];
            });
        }
    }
};
</script>

<style scoped>

</style>
